import { createSlice, createDraftSafeSelector } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  isSignedIn: false,
  formStep: 1,
  forms: []
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setIsSignedIn: (state, action) => {
      state.isSignedIn = action.payload;
    }
    // setFormStep: (state, action) => {
    //   state.formStep = action.payload;
    // },
    // setFormData: (state, action) => {
    //   state.forms.push(action.payload);
    // }
  }
});

export const { setIsLoading, setIsSignedIn } = appSlice.actions;
export default appSlice.reducer;

const selectSelf = (state) => state;

export const isSignedInSelector = createDraftSafeSelector(
  selectSelf,
  (state) => state.app.isSignedIn
);

export const isLoadingSelector = createDraftSafeSelector(
  selectSelf,
  (state) => state.app.isLoading
);
